import { TablePagination, TablePaginationProps, styled } from "@mui/material";

const StyledTablePagination = styled(TablePagination)<TablePaginationProps & { component?: React.ElementType }>(
  ({ theme }) => {
    return {
      "& .color": {
        color: theme.palette.text.secondary
      },
      "& .MuiSelect-icon": {
        color: theme.palette.text.secondary // Change the color to your desired color
      },
      "& .MuiTablePagination-root": {
        borderBottom: "none" // Remove the bottom border
      }
    };
  }
);

export default StyledTablePagination;
